// Each status from the new Bookkeeper Portal flow and the legacy status it's
// shown as here. Everything before the accountant picks it up is still "Ready
// to start", so Submitted to your accountant is the accountant's work list.
const legacyStatusByNewStatus = {
  PREPARING: 'OPEN', // Preparation
  OPEN: 'OPEN', // Payment & Terms
  AWAITING_INFORMATION: 'OPEN', // Bookkeeper Prepares Tax Return
  AWAITING_APPROVAL: 'OPEN', // Client Review & Approvals
  PREPARING_SUBMISSION: 'READY_FOR_REVIEW', // Accountant Prepares Final Documents
  READY_FOR_REVIEW: 'AWAITING_APPROVAL', // Client Final Review & Digital Approval
  READY_TO_FILE: 'READY_TO_FILE', // Accountant Submits to HMRC
  SUBMITTED_TO_HMRC: 'SUBMITTED_TO_HMRC', // Final Client Instructions
};

// Self assessments with an assignee are on the new Bookkeeper Portal flow, so
// their status is mapped back to the legacy status it was set from. Those
// without one are legacy self assessments and keep their status as is.
const getLegacyStatus = (selfAssessment) => {
  const { status, assignee, declarationConfirmed } = selfAssessment || {};

  if (!assignee) return status;

  // Once the client has signed the declaration it's approved and ready to
  // file, even while it's still with them on their final review
  if (status === 'READY_FOR_REVIEW' && declarationConfirmed) {
    return 'READY_TO_FILE';
  }

  return legacyStatusByNewStatus[status] || status;
};

export default getLegacyStatus;
